import React from 'react'
import "./Project.css"
// import img1 from "../../assets/Movie1.png" 
import { Link } from 'react-router-dom'
import {HiLocationMarker} from "react-icons/hi"
import pdfLink from "../../assets/Model.pdf"
const Project = () => {
  return (
    <div className='Project_container'>
    <div className="title">
        <h2>Model & Project Expo</h2>            
    </div>
    <div className="evt_data">
        <div className="left">
            {/* <img src={img1} alt="" /> */}
        </div>
        <div className="right">
            <div className="r_detail">
            <p>Mar 14,2023</p>
            <h2>Project Presetntation (Team)</h2>
            </div>
            <div className="reg_data">
                <div className="flex-cont">
            <div className="evt_reg">
                <p>For School Students </p>
                <h2>Entry Fee : Free</h2>
                <div className="reg_btns">
                <Link to="https://forms.gle/pB34mkMJN9s49Aft8" target="_blank" className="reg_btn">Register Now</Link>
                </div>
                </div>
            <div className="evt_reg">
                <p>For College Students </p>
                <h2>Entry Fee : Rs. 100</h2>
                <div className="reg_btns">
                <Link to="https://forms.gle/ZLuhjPAk9exQACNa7" target="_blank" className="reg_btn">Register Now</Link>
                </div>
                </div>
            </div>
            <div className="desc">
                <h3>Description</h3>
                 <p>To fulfill the strong desire of the students to showcase their technical competence along with innovative ideas in the form of projects.To provide a platform to exhibit student' s project management, team building skills and competitive spirit of the students.To provide exposure to the students for internship and job opportunities.</p>
                 <Link to={pdfLink} target="_blank" className="reg_btn">Rules & Regulations</Link>
            </div>
            <div className="date">
                <h3>Date & Time</h3>
                <div className="date_data">
                    <h4>Mar 14,2023</h4>
                </div>
            </div>
            <div className="loc">
                <h3>Location</h3>
                <p> <HiLocationMarker/>College of Engineering and Technology,Akola</p>
            </div>
            <div className="team">
                <h3><span>Coordinator</span> Team</h3>
                <div className="staf_team">
                    <h4>Staff Co-ordinator</h4>
                    <p>Rachna jaiswal : +91  90110 23942</p>
                </div>
                <div className="team_data">
                    <h4>Student Co-ordinator</h4>
                    <p>Adhiraj Deshmukh : +91 7498066831</p>
                    <p>Isha Lohiya : +91 93079 38373 </p>
                    <p>Sakshi Baggrecha : +91 94051 69186</p>
                    <p>Mayur Joshi : +91 9765244547</p>
                    <p> Prajwal Dalvi : +91 93091 74798</p>
                    <p> Aniket Chavhan : +91  9881469472</p>
                    <p> Bhavesh Vilhekar : +91 81779 65656 </p>
                    <p> Bhushan pophle : +91  95270 59695</p>
                    <p> Nikhil Amle: +91 95034 87979</p>
                </div>
            </div>
            </div>
        </div>
    </div>
</div>
  )
}

export default Project